(function(){

const THRESHOLD = 5000;
const GIFT_ID = 45555598033075;

let busy = false;


async function getCart(){

 const res = await fetch('/cart.js');
 return await res.json();

}


async function updateGift(){

if(busy) return;

busy = true;


let cart = await getCart();


let subtotal = 0;
let gift = null;


cart.items.forEach(item=>{

 if(item.variant_id === GIFT_ID){

  gift = item;

 }else{

  subtotal += item.final_line_price;

 }

});


subtotal = subtotal / 100;



/* progress bar */

const bar =
document.querySelector("#gift-progress-fill");


const msg =
document.querySelector("#gift-progress-message");


if(bar && msg){


bar.style.width =
Math.min(
(subtotal / THRESHOLD)*100,
100
)+"%";


if(subtotal >= THRESHOLD){

msg.innerHTML =
"🎉 Congratulations! FREE Eazicolor Tote Bag unlocked";


}else{


msg.innerHTML =
`You are Rs.${Math.ceil(THRESHOLD-subtotal)} away from getting a FREE Eazicolor Tote Bag`;


}


}



/* ADD FREE TOTE */

if(
subtotal >= THRESHOLD &&
!gift
){

console.log("Gift condition passed");

console.log("Adding free tote...");

await fetch('/cart/add.js',{
 method:"POST",
 headers:{
  "Content-Type":"application/json"
 },
 body:JSON.stringify({
  items:[
   {
    id:45555598033075,
    quantity:1
   }
  ]
 })
})
.then(r=>r.json())
.then(data=>{
 console.log("Tote added",data);
});

}



/* FORCE ONLY ONE */

if(
gift &&
gift.quantity > 1
){

await fetch('/cart/change.js',{

method:"POST",

headers:{
"Content-Type":"application/json"
},

body:JSON.stringify({

id:gift.key,
quantity:1

})

});

}



/* REMOVE BELOW 5000 */

if(
subtotal < THRESHOLD &&
gift
){

await fetch('/cart/change.js',{

method:"POST",

headers:{
"Content-Type":"application/json"
},

body:JSON.stringify({

id:gift.key,
quantity:0

})

});

}



busy=false;


}



document.addEventListener(
"DOMContentLoaded",
function(){

setTimeout(updateGift,1000);

});


document.addEventListener(
"click",
function(){

setTimeout(updateGift,800);

});


})();